import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutFuelSurchargeCycleCodesList extends Layout {
    layoutheaderFSCycleCodes: LayoutHeader;
    sourceFscCycle: DataSource;
    tablefscCycle: Table;
}
